import { ReactNode } from 'react';

import BookACall from 'components/BookACall';
import JobQuote from 'components/JobQuote';
import LayoutV2 from 'components/LayoutV2';
import MobileHelpButton from 'components/MobileHelpButton';
import useBreakpoint from 'hooks/useBreakpoint';
import { useApplyContext } from 'pages/Apply/context';

import ApplyBackButton from './ApplyBackButton';
import ProgressHeaderIndicator from './ProgressHeaderIndicator';
import ProgressSidebar from './ProgressSidebar';

export interface ApplyLayoutProps {
  children: ReactNode;
}

const ApplyLayout: React.FunctionComponent<ApplyLayoutProps> = function ({
  children,
}) {
  const underBreakpoint = useBreakpoint(1024);
  const { job, jobCompanyInfo, isLoading, rateTitle } = useApplyContext();
  return (
    <LayoutV2
      sidePanel={underBreakpoint ? null : <ProgressSidebar />}
      header={<ProgressHeaderIndicator />}
      footer={<MobileHelpButton />}
    >
      <div className="flex flex-col flex-1 max-w-6xl mx-auto">
        <div className="block md:hidden -mx-4 -mt-4">
          <JobQuote
            job={job}
            jobCompanyInfo={jobCompanyInfo}
            isLoading={isLoading}
            variant="compact"
          />
        </div>
        <div className="hidden md:block">
          <div className="-ml-4">
            <ApplyBackButton />
          </div>
        </div>
        <h1 className="text-20-24-em sm:text-24-28-em md:text-32-40-em mt-4 md:mt-6">
          Apply For Finance
        </h1>
        {rateTitle && (
          <h3 className="text-12-18-b sm:text-14-22-b mt-1 md:mt-0 text-neutral-700">
            {rateTitle}
          </h3>
        )}
        <div className="border-b border-neutral-300 w-full my-4 md:mb-6 lg:mt-6 lg:mb-10" />
        <div className="w-full grid grid-cols-1 md:grid-cols-12 gap-x-8">
          <div className="flex flex-col col-span-1 md:col-span-7">
            {children}
          </div>
          <div className="hidden md:block col-span-5">
            <div className="sticky top-24 flex flex-col gap-y-6">
              <BookACall application />
              <JobQuote
                job={job}
                jobCompanyInfo={jobCompanyInfo}
                isLoading={isLoading}
                variant="collapsible"
              />
            </div>
          </div>
        </div>
      </div>
    </LayoutV2>
  );
};

export default ApplyLayout;
